export default __webpack_public_path__ + "static/media/2f78143d2bf5d361360f1f7b019cfb45.svg";